import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { Subject, Subscription, throttleTime } from 'rxjs'
import {
  DashboardComponent,
  DashboardUserAction,
} from '../dashboard/dashboard.component'
import {
  Card,
  Contract,
  ContractDeclarationGame,
  contractDeclarationGameNull,
  ContractDeclarationService,
  ContractType,
} from 'game-services'
import { playerScoreCardNull } from 'game-play-services'

@Component({
  selector: 'sans-contract-declaration',
  standalone: true,
  imports: [DashboardComponent],
  templateUrl: './contract-declaration.component.html',
  styleUrl: './contract-declaration.component.scss',
})
export class ContractDeclarationComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() public contractDeclarationGame: ContractDeclarationGame =
    contractDeclarationGameNull

  @Input() public userPlayerScoreCard = playerScoreCardNull
  @Input() public leftOpponentPlayerScoreCard = playerScoreCardNull
  @Input() public rightOpponentPlayerScoreCard = playerScoreCardNull
  @Output() public gameUpdated = new EventEmitter<void>()

  public talonCards: Card[] = []
  public userCards: Card[] = []
  public rightOpponentCards: Card[] = []
  public leftOpponentCards: Card[] = []
  public isUserCardsSelectable = false
  public isOptionsDisabled = false
  public userActions: DashboardUserAction[] = []

  private declareContractClicks = new Subject<Contract>()
  private declareContractClicksSubscription = new Subscription()

  public constructor(
    private readonly contractDeclarationService: ContractDeclarationService,
  ) {}

  public async ngOnInit(): Promise<void> {
    this.declareContractClicksSubscription = this.declareContractClicks
      .pipe(throttleTime(1000))
      .subscribe(async (contract) => {
        if (this.contractDeclarationGame.user.bid.isHandType()) {
          await this.contractDeclarationService.declareHandContract(
            this.contractDeclarationGame.gamePlayGameId,
            contract,
          )
        } else {
          await this.contractDeclarationService.declareContract(
            this.contractDeclarationGame.gamePlayGameId,
            contract,
            this.contractDeclarationGame.getTalonCards(),
          )
        }
        this.gameUpdated.emit()
      })
  }

  public ngOnChanges(): void {
    this.talonCards = this.contractDeclarationGame.getTalonCards()
    this.userCards = this.contractDeclarationGame.user.getCards()

    this.rightOpponentCards =
      this.contractDeclarationGame.rightOpponent.originalCards

    this.leftOpponentCards =
      this.contractDeclarationGame.leftOpponent.originalCards

    this.isUserCardsSelectable =
      this.contractDeclarationGame.getIsUserCardsSelectable()

    this.isOptionsDisabled = this.contractDeclarationGame.getIsOptionsDisabled()

    this.userActions = this.contractDeclarationGame.userContractOptions.map(
      (contractOption) => {
        return {
          buttonLabel: contractOption.contractNameAsOption,
          value: contractOption.contractType,
        }
      },
    )
  }

  public ngOnDestroy(): void {
    this.declareContractClicksSubscription.unsubscribe()
  }

  public onUserCardSelected(card: Card): void {
    this.contractDeclarationGame.selectUserCard(card)
    this.ngOnChanges()
  }

  public onTalonCardSelected(card: Card): void {
    this.contractDeclarationGame.selectTalonCard(card)
    this.ngOnChanges()
  }

  public async onUserActionSelected(
    userAction: DashboardUserAction,
  ): Promise<void> {
    this.declareContractClicks.next(
      new Contract(userAction.value as ContractType),
    )
  }
}
